var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.5 276.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0abf00;}.cls-2{fill:#4d51f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,271.87h-.24c-2.59,2.77-6.41,4.56-12.08,4.56C8,276.43,0,266.88,0,254.5c0-12.81,8.62-21.93,22.67-21.93,11.33,0,18.42,6.28,19.46,14.05H31.05c-.74-2.47-3.45-4.69-8.38-4.69-6.65,0-11.09,4.69-11.09,12.57s4.19,12.57,11.09,12.57c5.23,0,9-2.53,9.55-6.9H22.67v-7.89H41.89v23.41H34.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.33,233.31H84c10.84,0,16.75,5.3,16.75,13.92a13.42,13.42,0,0,1-8.56,12.94l10.29,15.52H90.19l-8.81-14H74.66v14H63.33Zm11.33,8.62v11.34H83c3.94,0,6.16-2.34,6.16-5.92,0-3.32-2.22-5.42-6.16-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.49,233.31h33.26v9.12H132.82v7.39h18v8.38h-18v8.37h22.67v9.12h-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.21,233.31h33.26v9.12H186.54v7.39h18v8.38h-18v8.37h22.67v9.12h-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.93,233.31h9.85l18.73,23.16h.25l-.25-23.16h11.33v42.38h-9.61l-19-23.41H240l.24,23.41H228.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.4,233.31h15.4c8.93,0,13.92,5.42,13.92,13.06s-5,13.3-13.92,13.3H294.48v16H291.4Zm3.08,2.65V257h12.44c7,0,10.72-4.62,10.72-10.66S313.94,236,306.92,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.8,233.31h3.57l16.14,42.38h-3.2l-5-13.24H341.73l-5,13.24h-3.08Zm1.66,3.2-8.75,23.29h17.62l-8.74-23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.9,258.57l-15.4-25.26H383l13.49,22.05h.12l13.67-22.05h3.27l-15.52,25v17.37H394.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mxtk5D"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.28,49.1c10.48-8.9,14.38-10.69,22.78-10.58.32.32.91.65.9,1-.66,24,1.06,48.47-2.71,72C232,138.39,202,156.9,175.43,153.29c-29.83-4-51-28-50.85-57.59a57.09,57.09,0,0,1,49.36-56.65C189.2,37,202.77,41,215.28,49.1Zm-5.53,47.06a28.07,28.07,0,1,0-28.56,28A28.11,28.11,0,0,0,209.75,96.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.17,216.72c6.36-15.26-1.42-31.6-17.72-37.66-16.93-6.3-34-12.34-50.94-18.51-9.11-3.31-18.21-6.66-27.22-10-7,11.34-1.62,28.16,11.48,35,7.14,3.72,15,6.16,22.55,9,18.91,7,37.85,13.86,56.79,20.75C226.78,215.88,228.52,216.26,230.17,216.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.53,29.55a15,15,0,0,1-15-14.31C199.35,7.56,206.15.29,213.77,0c7.91-.29,15.28,6.86,15.3,14.85A14.68,14.68,0,0,1,214.53,29.55Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/authLogo.c6f2d5f472555301ebedbfa4858d420f.svg";
export { ForwardRef as ReactComponent };